import { Resource as e, API as o } from "@coveo/platform-client";
const t = class t extends e {
  /**
   * Returns a list of extensions for the specified project.
   *
   * @param {string | undefined} projectId ID of the project for which to retrieve extensions
   * @param {ListExtensionsOptions} options Options to filter and paginate the results.
   * @returns {Promise<ExtensionModel[]> | PageModel<ExtensionModel>} List of extensions for the specified project.
   */
  listExtensionsByProjectId(i, r = {}) {
    return this.api.get(
      this.buildPath(`${t.baseUrl}/project`, {
        ...r,
        projectId: i
      })
    );
  }
};
t.baseUrl = `/rest/organizations/${o.orgPlaceholder}/extensions`;
let s = t;
export {
  s as ExtensionInternalResource
};
//# sourceMappingURL=ExtensionInternalResource.js.map
